<div class="territory-control">
  <div *ngIf="layerHidden && rows.length" class="br-text-muted br-small br-fst-italic br-mb-2">
    Layer hidden — use the eye above to draw it.
  </div>

  <ng-container *ngIf="rows.length === 0; else roster">
    <p class="br-text-muted br-small br-mb-2">
      No territories to show.
    </p>
  </ng-container>

  <ng-template #roster>
    <div class="br-text-muted br-small br-mb-1">{{ rows.length }} boundaries</div>
    <div class="roster br-mb-2">
      <button *ngFor="let row of rows"
              type="button"
              class="territory-row"
              [class.territory-selected]="isSelected(row)"
              [title]="row.name"
              (click)="pick(row)">
        <span class="territory-swatch" [style.background-color]="colorOf(row)"></span>
        <span class="territory-name">{{ row.name }}</span>
        <span *ngIf="leadCount(row) !== null" class="territory-count">{{ leadCount(row) }}</span>
      </button>
    </div>
  </ng-template>
</div>
